import { useEffect, useRef } from 'react';

import { useStore } from '../store';
import { runBoot } from './boot';

/** Runs the boot sequence once per app instance and exposes its status from the store. */
export function useBoot() {
  const started = useRef(false);
  const boot = useStore((s) => s.boot);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void runBoot({ store: useStore });
  }, []);
  const retry = () => void runBoot({ store: useStore });
  return { ...boot, retry };
}
